export default {
	styleOverrides: {
		root: ({ ownerState, theme }) => ({
			...(theme.themeKey === 'internal' &&
				ownerState.variant === 'EveHeadingDivider' && {
					marginTop: theme.spacing(2),
					marginBottom: theme.spacing(3),
				}),
			...(theme.themeKey === 'internal' &&
				ownerState.variant === 'EvePaperDivider' && {
					marginTop: theme.spacing(1),
					marginBottom: theme.spacing(3),
				}),
		}),
	},
};
